import { useMutation } from "@tanstack/react-query";
import { insightsApi } from "../api";
import type { ComparisonSummaryRequest } from "../api";

/**
 * On-demand AI summary of the current dashboard view. Mutation (not query) so
 * it only calls OpenAI when the user clicks "Generate AI summary".
 */
export const useComparisonSummary = () =>
  useMutation({
    mutationFn: (payload: ComparisonSummaryRequest) =>
      insightsApi.getComparisonSummary(payload),
  });
